module.exports = __webpack_public_path__ + "static/HGA-6ced25e2e764b83627a1be1c98289b0e.png";